<div class="cout-decoupage-pondere cursorHelp" *ngIf="display()" pTooltip="coût unitaire moyen pondéré pour '{{cellule.libelleDecoupageRepas.toUpperCase()}}'" >
 <i class="fas fa-balance-scale fa-xs mg-r-5"></i> {{cellule.coutUnitairePondere | currency:'EUR':'symbol':'1.4-4'}}
</div>
